module.exports = __webpack_public_path__ + "static/media/app.4130de34.png";